<template>
    <md-icon class="md-icon-image" v-once>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <g>
                <circle cx="256" cy="256" r="256" fill="#003C8F"/>
                <path fill="#FFFFFF" d="M277.25,176.31V86H144.44a15.91,15.91,0,0,0-15.94,15.94V410.06A15.91,15.91,0,0,0,144.44,426H367.56a15.91,15.91,0,0,0,15.94-15.94V192.25H293.19A16,16,0,0,1,277.25,176.31Zm43.28,143.45H277.25v53.12a10.62,10.62,0,0,1-10.62,10.63H245.38a10.62,10.62,0,0,1-10.63-10.63V319.76H191.47A10.63,10.63,0,0,1,184,301.59L248,238a11.33,11.33,0,0,1,16,0l64,63.55A10.62,10.62,0,0,1,320.53,319.76Zm58.32-164-65-65.08A15.93,15.93,0,0,0,302.55,86H298.5v85h85V167A15.87,15.87,0,0,0,378.85,155.73Z"/>
            </g>
        </svg>
    </md-icon>
</template>

<script>
    import MdIcon from "../../../components/MdIcon/MdIcon";

    export default {
        name: 'GdDoUploadIcon',
        components: {
            MdIcon
        }
    }
</script>
